module.exports = __webpack_public_path__ + "media/images/icons/trash-outline-b542dd50dea515f49175371c4dc73593.svg";